import { get } from 'lodash';

const styles = ({ breakpoint, color, fontSize, typography, margin, padding }) => ({
  content: {
    margin: get(margin, 'm36'),
    backgroundColor: get(color, 'background'),
    marginTop: get(margin, 'm0'),
  },
  gridContainer: {
    backgroundColor: get(color, 'uiBackground'),
    marginTop: get(margin, 'm10'),
    marginBottom: get(margin, 'm60'),
  },
  leftSideBar: {
    paddingTop: get(padding, 'p50'),
    backgroundColor: get(color, 'uiBackground'),
  },
  mainContent: {
    padding: get(padding, 'p20'),
    paddingTop: get(padding, 'p50'),
    backgroundColor: get(color, 'uiBackground'),
  },
  rightSideBar: {
    padding: get(padding, 'p10'),
    paddingTop: get(padding, 'p50'),
    backgroundColor: get(color, 'uiBackground'),
    borderLeft: `8px solid ${get(color, 'background')}`,
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: get(margin, 'm6'),
    marginBottom: get(margin, 'm0'),
  },
  subTitle: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'bodyText'),
    marginTop: get(margin, 'm6'),
    marginBottom: get(margin, 'm10'),
  },
  fileLabel: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  switchContainer: {
    height: '2%',
    width: '100%',
    marginTop: get(margin, 'm20'),
  },
  sslEnabledLabel: {
    width: '89%',
    float: 'left',
    marginTop: 0,
  },
  hr: {
    color: get(color, 'border'),
    borderTopWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    width: '100%',
  },
  helperText: {
    clear: 'both',
  },
  helperBodyText: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'bodyText'),
    clear: 'both',
    fontSize: get(fontSize, 'bodyText'),
  },
  cellText: {
    verticalAlign: 'middle',
  },
  disableField: {
    '& input': {
      backgroundColor: get(color, 'gray'),
    },
  },
  attributeFieldContainer: {
    margin: `${0} !important`,
  },
  attributeTextFieldContainer: {
    padding: `${0} !important`,
  },
  defaultInputClass: {
    maxWidth: '45%',
    width: '45%',
    float: 'left',
  },
  defaultTextClass: {
    width: '10% !important',
    marginRight: '0 !important',
  },
  defaultTextClass1: {
    width: '22% !important',
    maxWidth: '100% !important',
    height: '22px',
    textWrap: 'nowrap',
    whiteSpace: 'nowrap',
  },
  textConfigField: {
    margin: '0 !important',
    marginBottom: '20px !important',
  },
  configContainer: {
    clear: 'both',
  },
  configCheckContainer: {
    width: '5%',
    float: 'left',
    height: '40px',
    paddingTop: '30px',
  },
  configCellContainer: {
    width: '92%',
    float: 'left',
    marginLeft: '2px',
  },
  helpText: {
    color: `${get(color, 'smallText')} !important`,
    fontFamily: `${get(typography, 'smallText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    marginTop: '-15px',
  },
  warningIcon: {
    color: get(color, 'warning'),
    marginLeft: get(margin, 'm10'),
    marginRight: get(margin, 'm4'),
    fontSize: 14,
    marginTop: get(margin, 'm4'),
  },
  [`@media (max-width: ${get(breakpoint, 'md')})`]: {
    defaultInputClass: {
      maxWidth: '42%',
      width: '42%',
      float: 'left',
    },
  },
  deleteContainer: {
    float: 'right',
    marginRight: get(margin, 'm10'),
  },
  addRoleButton: {
    fill: get(color, 'primaryButtonBackground'),
  },
  addRoleButtonDisabled: {
    fill: get(color, 'borderColor'),
  },
  roleCell: {
    width: '95%',
    paddingRight: 0,
  },
  plusButtonCell: {
    verticalAlign: 'middle',
    margin: 0,
    padding: 0,
    minWidth: 40,
  },
  plusButton: {
    minWidth: 0,
    '&:disabled': {
      backgroundColor: `${get(color, 'uiBackground')} !important`,
      border: '0px !important',
    },
  },
  roleInnerTable: {
    padding: 0,
  },
  roleInnerTableTbody: {
    "& tr": {
      "& td" : {
        borderBottom: '0px !important',
      },
    },
  },
  clearIcon: {
    width: 18,
    height: 18,
  },
  roleMappingPortalRoleCell: {
    verticalAlign: 'top',
    paddingTop: 20,
    width: '40%',
  },
});

export default styles;
